import { render, staticRenderFns } from "./form-document-fields.vue?vue&type=template&id=4df682c6&scoped=true&lang=pug"
import script from "./form-document-fields.vue?vue&type=script&lang=js"
export * from "./form-document-fields.vue?vue&type=script&lang=js"
import style0 from "./form-document-fields.vue?vue&type=style&index=0&id=4df682c6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4df682c6",
  null
  
)

export default component.exports